<template src="./PanelIconValues.html">
</template>

<script>

export default {
    name: "PanelIconValues",
    props: {
        title: {
            required: false,
            type: String,
        },
        subtitle: {
            required: false,
            type: String,
        },
        icon: {
            required: false,
            type: String,
        },
        max: {
            required: false,
            type: String,
        },
        maxDescription: {
            required: false,
            type: String,   
        },
        avg: {
            required: false,
            type: String,
        },
        avgDescription: {
            required: false,
            type: String,   
        },
        min: {
            required: false,
            type: String,
        },
        minDescription: {
            required: false,
            type: String,   
        },
        endyear: {
            required: false,
            type: String,
        },
        endyearDescription: {
            required: false,
            type: String,   
        },

    },
}
</script>

<style lang="scss" src="./PanelIconValues.scss"> </style>